import React from "react";
import { t } from "i18next";

import logoIcon   from "../../../assets/icons/logo.svg";
import closeIcon  from "../../../assets/icons/close.svg";
import userIcon   from "../../../assets/icons/user.svg";
import historyIcon from "../../../assets/icons/history.svg";
import phoneIcon  from "../../../assets/icons/phone.svg";
import fileIcon   from "../../../assets/icons/file.svg";
import noteIcon   from "../../../assets/icons/note.svg";
import infoIcon   from "../../../assets/icons/info.svg";

const NAV_LINKS = [
    { label: () => t("aboutUs"),       href: "/aboutus",          icon: userIcon   },
    { label: () => t("notifications"), href: "/notifications",    icon: historyIcon},
    { label: () => t("contacts"),      href: "/aboutus#contacts", icon: phoneIcon  },
    { label: () => t("privacyPolicy"), href: "/aboutus#policy",   icon: fileIcon   },
    { label: () => t("termsOfUse"),    href: "/aboutus#terms",    icon: noteIcon   },
    { label: () => t("FAQ"),           href: "/aboutus#faq",      icon: infoIcon   },
];

const GREEN_FILTER  = "[filter:brightness(0)_saturate(100%)_invert(18%)_sepia(70%)_saturate(6415%)_hue-rotate(142deg)_brightness(93%)_contrast(84%)]";
const GREY_FILTER   = "[filter:brightness(0)_saturate(100%)_invert(55%)_sepia(0%)_saturate(0%)_brightness(95%)]";
const WHITE_FILTER  = "[filter:brightness(0)_invert(1)]";

function Navigation({ onClose }) {
    return (
        <div className="flex flex-col h-full overflow-hidden">

            {/* ── Green header ──────────────────────────────── */}
            <div className="bg-[#147F26] px-5 pt-5 pb-6 shrink-0">
                <div className="flex items-center justify-between mb-6">
                    <img src={logoIcon} alt="Agroland" className={`h-7 ${WHITE_FILTER}`} />
                    <button
                        onClick={onClose}
                        className="w-9 h-9 rounded-full bg-white/20 hover:bg-white/30
                            flex items-center justify-center border-none cursor-pointer
                            transition-colors duration-150 shrink-0"
                    >
                        <img src={closeIcon} alt="close" width={16} height={16} className={WHITE_FILTER} />
                    </button>
                </div>
                <p className="m-0 text-white/70 text-xs font-semibold tracking-widest uppercase">
                    {t("navigation")}
                </p>
            </div>

            {/* ── Nav links ─────────────────────────────────── */}
            <nav className="flex-1 overflow-hidden px-3 py-3">
                <ul className="list-none p-0 m-0 flex flex-col gap-0.5">
                    {NAV_LINKS.map(({ label, href, icon }) => (
                        <li key={href}>
                            <a
                                href={href}
                                onClick={onClose}
                                className="flex items-center gap-3 px-3 py-2.5 rounded-xl
                                    no-underline text-[#222222] text-[14px] font-medium
                                    hover:bg-[#f0faf2] hover:text-[#147F26]
                                    transition-all duration-150 group"
                            >
                                <img
                                    src={icon}
                                    alt=""
                                    width={17}
                                    height={17}
                                    className={`shrink-0 ${GREY_FILTER}
                                        group-hover:${GREEN_FILTER}
                                        transition-all duration-150`}
                                />
                                <span className="flex-1 leading-snug">{label()}</span>
                                <svg className="shrink-0 opacity-25 group-hover:opacity-60 transition-opacity duration-150 text-[#147F26]"
                                    width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2.5"
                                        strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
}

export default Navigation;
